import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

const Header = () => {
  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container">
        <Link className="navbar-brand fw-bold" to="/">
          AI Tools Benefits
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#nav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="nav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="#">Courses</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="#">Blog</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="#">Contact</Link>
            </li>
            <li className="nav-item ms-3">
            <Link to="/login" className="btn btn-main">login</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
